import { CancelableRequest } from "@fino/ng1-request";
import { DataResponse } from "@fino/ng1-response/lib";

export class ConsorsUserInitService extends CancelableRequest {
	constructor($http, $q, appConfig, configService) {
		"ngInject";
		super({ $http, $q, appConfig, configService });
	}

	get api() {
		return this.appConfig.get().api.path;
	}

	getUser(userId, sig, exp) {
		return this.$http({
			method: "GET",
			params: {
				exp,
				sig,
			},
			url: `${this.api}/user/${userId}`,
		}).then(DataResponse.transform("data"));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/consorsUserInit/consorsUserInit.service.js